var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property, query, queryAssignedNodes, } from 'lit/decorators.js';
import './toolbar-dropdown.js';
let ExEditorToolbarSelectElement = class ExEditorToolbarSelectElement extends LitElement {
    constructor() {
        super(...arguments);
        this.active = false;
        this.disabled = false;
        this.in = '';
        this.label = '';
        this.shortcut = '';
        this._value = '';
    }
    set value(val) {
        const oldVal = this._value;
        this._value = val;
        this.setOptionsSelected();
        this.requestUpdate('value', oldVal);
    }
    get value() {
        return this._value;
    }
    closeDropdown() {
        this.button.closeDropdown();
    }
    openDropdown() {
        this.button.openDropdown();
    }
    setOptionsSelected() {
        this.options.forEach((option) => {
            option.selected = this.value === option.value;
        });
    }
    handleClickPopContent(e) {
        if (e.defaultPrevented) {
            return;
        }
        this.closeDropdown();
    }
    handleClickButton() {
        if (this.separateDropdown) {
            if (this.button.isDropdownOpen) {
                this.closeDropdown();
            }
            else {
                this.openDropdown();
            }
        }
    }
    render() {
        return html `
      <exeditor-toolbar-button
        ?active=${this.active}
        ?disabled=${this.disabled}
        in=${this.in}
        label=${this.label}
        shortcut=${this.shortcut}
        scrollOverflowPopContent
        ?separateDropdown=${this.separateDropdown}
        @buttonclick=${this.handleClickButton}
        hasDropDown=${this.options.length > 0}
      >
        <slot></slot>
        <div slot="pop-content" @click="${this.handleClickPopContent}">
          <slot name="option" @slotchange=${this.setOptionsSelected}></slot>
        </div>
      </exeditor-toolbar-button>
    `;
    }
};
ExEditorToolbarSelectElement.styles = [
    css `
      :host {
        display: inline-flex;
        font-size: 14px;
      }
      :host([in='dropdown']) {
        display: block;
      }
    `,
];
__decorate([
    property({
        type: Boolean,
        reflect: true,
    })
], ExEditorToolbarSelectElement.prototype, "active", void 0);
__decorate([
    property({
        type: Boolean,
        reflect: true,
    })
], ExEditorToolbarSelectElement.prototype, "disabled", void 0);
__decorate([
    property({ reflect: true })
], ExEditorToolbarSelectElement.prototype, "in", void 0);
__decorate([
    property({ reflect: true })
], ExEditorToolbarSelectElement.prototype, "label", void 0);
__decorate([
    property({ reflect: true })
], ExEditorToolbarSelectElement.prototype, "shortcut", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], ExEditorToolbarSelectElement.prototype, "separateDropdown", void 0);
__decorate([
    property({ reflect: true })
], ExEditorToolbarSelectElement.prototype, "value", null);
__decorate([
    query('exeditor-toolbar-button')
], ExEditorToolbarSelectElement.prototype, "button", void 0);
__decorate([
    queryAssignedNodes({ slot: 'option' })
], ExEditorToolbarSelectElement.prototype, "options", void 0);
ExEditorToolbarSelectElement = __decorate([
    customElement('exeditor-toolbar-select')
], ExEditorToolbarSelectElement);
export { ExEditorToolbarSelectElement };
let ExEditorToolbarOptionElement = class ExEditorToolbarOptionElement extends LitElement {
    constructor() {
        super();
        this.value = '';
        this.selected = false;
        this.addEventListener('mousedown', (e) => e.preventDefault());
    }
    render() {
        return html `<slot></slot>`;
    }
};
ExEditorToolbarOptionElement.styles = css `
    :host {
      display: flex;
      align-items: center;
      position: relative;
      height: var(--exeditor-toolbar-option-height, 36px);
      padding: var(--exeditor-toolbar-option-padding, 0 16px);
      white-space: nowrap;
      cursor: pointer;
      transition: background-color 100ms ease;
    }
    :host(:hover) {
      background-color: var(--exeditor-toolbar-option-hover-color, #f0f0f0);
    }
    :host([selected]) {
      font-weight: var(--exeditor-toolbar-option-selected-font-weight, bold);
    }
  `;
__decorate([
    property({ reflect: true })
], ExEditorToolbarOptionElement.prototype, "value", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], ExEditorToolbarOptionElement.prototype, "selected", void 0);
ExEditorToolbarOptionElement = __decorate([
    customElement('exeditor-toolbar-option')
], ExEditorToolbarOptionElement);
export { ExEditorToolbarOptionElement };
//# sourceMappingURL=toolbar-select.js.map